module.exports = __webpack_public_path__ + "static/pauline-dd91a5fa6ae7f891adb2dc122beafb3e.png";